import React, { useState, useEffect } from 'react';
import { CartStackedProduct } from '../CartStackedProduct';
import useCartData from '@arctheme-hooks/useCartData';
import { ICart, ICartItem } from '@src/types/cart';
import { CartItem } from '../CartItem';

export const StackedLayout = ({
  settings,
  cartData,
  onQuantityChange,
  onRemoveItem
}: {
  settings: any;
  cartData: ICart;
  onQuantityChange?: (item: ICartItem, newQuantity: number) => void;
  onRemoveItem?: (item: ICartItem) => void;
}) => {
  const { block_settings, showDividers = false, removeItemBorders = false } = settings;
  const blockSettings = block_settings || {};

  // Extract spacing and divider settings
  const {
    item_gap = 0,
    padding_top = 0,
    padding_bottom = 0,
    padding_left_right = 0,
    margin_top = 0,
    margin_bottom = 0,
    margin_left_right = 0,
    item_divider_color = '#EDEDED',
    padding = 16
  } = blockSettings;

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: `${item_gap}px`,
    marginTop: `${margin_top}px`,
    marginBottom: `${margin_bottom}px`,
    marginLeft: `${margin_left_right}px`,
    marginRight: `${margin_left_right}px`,
    paddingTop: `${padding_top}px`,
    paddingBottom: `${padding_bottom}px`,
    paddingLeft: `${padding_left_right}px`,
    paddingRight: `${padding_left_right}px`
  };

  return (
    <ul style={containerStyle}>
      {cartData?.items?.map((item, index) => (
        <React.Fragment key={`${item.key}-${index}`}>
          <CartItem
            item={item}
            settings={{
              ...block_settings,
              removeItemBorders,
              itemPadding: padding
            }}
            index={index}
            type='cart'
            onQuantityChange={onQuantityChange}
            onRemoveItem={onRemoveItem}
            isFirstItem={index === 0}
          />
        </React.Fragment>
      ))}
    </ul>
  );
};
